import { PdMarkdownInput } from "./pd-markdown-input/PdMarkdownInput.js";
//#region src/pd-markdown-input/pd-markdown-input.ts
var tag = "pd-markdown-input";
if (!customElements.get(tag)) customElements.define(tag, PdMarkdownInput);
//#endregion
export { PdMarkdownInput };
